<template>
  <div class="px-10 py-5">
    <v-card elevation="0">
      <div class="d-flex align-center justify-space-between mb-6">
        <h3
          class="text--black text-uppercase"
          style="font-size: 18px; font-weight: 500"
        >
          Grafik Metode Transaksi
        </h3>
        <div class="d-flex">
          <v-select
            outlined
            multiple
            hide-details
            v-model="selectedPayment"
            :items="paymentItems"
            item-text="name"
            item-value="value"
            label="Metode"
            class="mr-4 rounded-lg"
            :menu-props="{
              location: 'bottom',
              origin: 'top center',
              transition: 'slide-y-transition',
              offsetY: true,
            }"
          >
            <template v-slot:selection="{ index }">
              <span class="mr-3" style="font-size: 14px" v-if="index < 1"
                >Metode</span
              >
              <div
                v-if="index === 0"
                class="circle-chip"
                :style="{
                  fontSize: '14px',
                  border: '1px solid #E16162',
                  color: 'white',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }"
              >
                {{ selectedPayment.length }}
              </div>
            </template>
            <template v-slot:item="{ item }">
              <span style="font-size: 14px">{{ item.title }}</span>
            </template>
          </v-select>

          <v-select
            outlined
            v-model="selectedPeriod"
            :items="periodItems"
            item-text="title"
            item-value="value"
            label="Periode"
            hide-details
            class="rounded-lg"
            :menu-props="{
              location: 'bottom',
              origin: 'top center',
              transition: 'slide-y-transition',
              offsetY: true,
            }"
          >
            <template v-slot:selection="{ item }">
              <span style="font-size: 14px">{{ item.title }}</span>
            </template>
            <template v-slot:item="{ item }">
              <span style="font-size: 14px">{{ item.title }}</span>
            </template>
          </v-select>
        </div>
      </div>

      <!-- Chart Container -->
      <div
        class="py-6 chart-container"
        style="position: relative; height: 400px"
      >
        <canvas ref="revenueChart"></canvas>
      </div>
    </v-card>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import * as constant from "@/constants/constant";

export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      periodItems: constant.periods,
      paymentItems: constant.payments,
      selectedPeriod: "",
      selectedPayment: [],
      chart: null,
    };
  },
  watch: {
    selectedPeriod() {
      this.emitDateUpdates();
    },
    selectedPayment() {
      this.emitDateUpdates();
    },
    data() {
      this.updateChart();
    },
  },
  computed: {
    processedData() {
      if (!this.data || this.data.length === 0) {
        return { labels: [], datasets: [] };
      }

      const labels = this.data.map((item) => {
        const date = new Date(item.date);
        const monthName = date.toLocaleString("default", { month: "short" });
        return `${date.getDate()} ${monthName}`;
      });

      const datasets = [
        {
          label: "Total Pendapatan",
          data: this.data.map((item) => Number(item.total)),
          backgroundColor: "#ABD1C6",
          borderColor: "#ABD1C6",
          borderWidth: 1,
        },
      ];

      return { labels, datasets };
    },
  },
  mounted() {
    this.initChart();
    this.emitDateUpdates();
  },
  beforeMount() {
    this.selectedPeriod = "daily";
    this.selectedPayment = ["BCA", "MDR", "BRI", "BNI", "CASH"];
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    emitDateUpdates() {
      this.$emit("update:selectedPeriod", this.selectedPeriod);
      this.$emit("update:selectedPayment", this.selectedPayment);
    },
    initChart() {
      if (this.chart) {
        this.chart.destroy();
      }

      const ctx = this.$refs.revenueChart.getContext("2d");
      this.chart = new Chart(ctx, {
        type: "bar",
        data: this.processedData || {
          labels: [],
          datasets: [],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: {
              grid: {
                display: true,
                color: "#f0f0f0",
              },
            },
            y: {
              grid: {
                display: true,
                color: "#f0f0f0",
              },
              ticks: {
                callback: function (value) {
                  return value.toLocaleString();
                },
              },
              suggestedMin: 0,
            },
          },
          plugins: {
            legend: {
              display: false,
            },
          },
        },
      });
    },
    updateChart() {
      if (this.chart) {
        this.chart.data = this.processedData;
        this.chart.update();
      }
    },
  },
};
</script>

<style scoped>
.v-select {
  max-width: 200px;
}

.circle-chip {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  text-align: center;
  line-height: 40px;
  background-color: #e16162;
}
</style>
